import {
  ReportingImportNormalizationIssue,
  ReportingImportNormalizationIssueCandidate,
} from '../reporting/reporting-import.model';

export enum MutateReportingImportNormalizationIssueRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  issueId = 'issueId',
  isResolved = 'isResolved',
  selectedCandidateId = 'selectedCandidateId',
}

export interface MutateReportingImportNormalizationIssueRequest {
  [MutateReportingImportNormalizationIssueRequestKeys.runId]?: string | null;
  [MutateReportingImportNormalizationIssueRequestKeys.uploadActionId]?: string | null;
  [MutateReportingImportNormalizationIssueRequestKeys.issueId]: string;
  [MutateReportingImportNormalizationIssueRequestKeys.isResolved]: boolean;
  [MutateReportingImportNormalizationIssueRequestKeys.selectedCandidateId]?: string | null;
}

export interface MutateReportingImportNormalizationIssueResponse {
  issue: ReportingImportNormalizationIssue;
  selectedCandidate: ReportingImportNormalizationIssueCandidate | null;
  unresolvedCount: number;
  resolvedCount: number;
  allResolved: boolean;
}
